import { getGetApiV1ThreeLetterCodePartnerAdminsBankAccountsUrl } from '@fukuri-admins/apis/client/gen/endpoints';
import { useDownloadCsv } from '@fukuri-admins/hooks/common';

type Options = {
  onSuccess?: (blob: Blob) => void;
  onError?: (error: Error) => void;
};

/**
 * 口座連携済みユーザー一覧 CSV ダウンロード hook
 *
 * `GET /partner_admins/bank_accounts?format=csv` で CSV を取得し、
 * ボタンクリック時（`trigger()` 呼び出し時）に 1 回だけダウンロードする。
 *
 * `user_ids[]` を指定すると検索で絞り込まれた利用者のみの CSV を取得できる。
 * 配列クエリは orval.config.ts の injectExplodeTrue transformer により
 * Orval URL 関数がキー繰り返し形式（`user_ids[]=1&user_ids[]=2`）で組み立てる。
 *
 * @param threeLetterCode - パートナーコード
 * @param userIds - フィルタリングする利用者 ID の配列（指定しない場合は全件出力）
 * @param options - 成功時 / 失敗時コールバック
 */
export const useGetBankAccountsCsv = (
  threeLetterCode: string,
  userIds?: number[],
  options?: Options
) => {
  const url = getGetApiV1ThreeLetterCodePartnerAdminsBankAccountsUrl(threeLetterCode, {
    format: 'csv',
    ...(userIds && userIds.length > 0 && { 'user_ids[]': userIds }),
  });

  return useDownloadCsv(url, options);
};
